
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">فرم اطلاعات برنامه ریزی مدیر</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ </label>
          <input disabled type="text" value="{{Selected_Schedule_Record.persianDate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ساعت شروع </label>
          <input disabled type="text" value="{{Selected_Schedule_Record.startDate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> ساعت پایان </label>
          <input disabled type="text" value="{{Selected_Schedule_Record.endDate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> توضیح </label>
          <input disabled type="text" value="{{Selected_Schedule_Record.dsc}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

    </form>


    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #396c9b; color: white;">
          <tr>
            <th>#</th>
            <th>نام</th>
            <th>نام خانوادگی</th>
            <th>کد ملی</th>
            <th>شماره همراه</th>
            <th>نام پدر</th>
            <th>سرپرست</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of Selected_Schedule_Record.expert">
            <td>{{Selected_Schedule_Record.expert.indexOf(detail)+1}}</td>
            <td>{{detail.name}}</td>
            <td>{{detail.familly}}</td>
            <td>{{detail.melicode}}</td>
            <td>{{detail.shomareh_Hamreh}}</td>
            <td>{{detail.name_Pedar}}</td>
            <td>
              <p *ngIf="detail.seleted">بله</p>
              <p *ngIf="!detail.seleted">خیر</p>
            </td>


          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>